import React from 'react';
import { Accordion, Card } from "react-bootstrap";

class Benefits extends React.Component  {
    render() {
        const {data, benefitsProduct, membershipPrice, membershipPriceLoading} = this.props;
        var benefits;
        if(data.benefits){
            benefits = data.benefits.map((item, index) =>
                    <Card key={index} className="benefits">
                        <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                            <div className="d-flex ">
                                <div className="mb-0 col-11 d-block d-md-none">
                                    {item.subtitle}
                                </div>
                                <div className="mb-0 col-1 d-block d-md-none">
                                    <img alt= "plus-symbol" src="/images/plus-symbol.png" width="22" />
                                </div>
                                <div className="mb-0 col-8 d-none d-md-block">
                                    {item.subtitle}
                                </div>
                                        
                                {item && item.explorer && (benefitsProduct === null ? '' : benefitsProduct[1].explorer) && (
                                    <div className="col-4 col-md-2 text-center">
                                        {item.explorer.content === false && (
                                            <img alt= "plus-symbol" src={item.explorer.image} width="15"/>
                                        )}
                                        {item.explorer.content !== false && item.explorer.content}
                                        {item.explorer.price === "EXPLORER" && 
                                        (membershipPriceLoading ? (<div className="spinner-border spinner-border-sm text-secondary" role="status">
                                        <span className="sr-only"></span>
                                    </div>) : !membershipPrice ? "Price not available" : "")}
                                    {/* </div>) : !membershipPrice ? "Price not available" : (membershipPrice.find(member => member.member_category.includes("EXPLORER MEMBERSHIP"))?.price))} */}
                                    </div>
                                )}
                                <div className="mb-0 col-1 d-none d-md-block">
                                    <img alt= "plus-symbol" src="/images/plus-symbol.png" width="22" />
                                </div>   
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={index+1}>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-12 col-md-8">
                                        <div>{item.description}</div>
                                        <div>{item.learnmore && (
                                            <a target='_blank' rel="noreferrer" href={item.learnmore.link}>{item.learnmore.text}</a>
                                        )}
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                );
        }

        return (
            <div className="container accordion-container mt-5 benefits-container mb-5">
                    <h4 className="col-12 benefits-header d-block d-md-none h4">{data.title}</h4>
                    {data.products && (
                        <div className="d-flex benefits-header-container">
                        <h4 className="col-8 benefits-header d-none d-md-block h4">{data.title}</h4>
                        {data.products && data.products.explorer && (benefitsProduct === null ? '' : benefitsProduct[1].explorer) && (
                                <div className="col-4 col-md-2 text-center">
                                    <div><img alt= "" src={data.products.explorer.image} width="50"/></div>
                                    <div>{data.products.explorer.name}</div>
                                    <div>{data.products.explorer.price}</div>
                                </div>       
                        )}
                    </div>
                    )}
                    <Accordion defaultActiveKey="0">
                        {benefits}
                    </Accordion>
            </div>  
        );   
    }    
}

export default (Benefits);